import perfil1 from "./assets/perfil1.png"
import perfil2 from "./assets/perfil2.png"

const testimonials = [
{
  name: "Manuela",
  company: "Senai",
  quote: "O benefício de se usar o React é que podemos expandir nossa aplicação, tendo quantas páginas quisermos, de modo muito simples, e adicionar muito conteúdo adicional.",
  image: perfil1
},
{
  name: "Turmalina",
  company: "Golofin",
  quote: "O benefício de se usar o React é que podemos expandir nossa aplicação, tendo .",
  image: perfil2
}
];

export default testimonials;
